import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SupportRequestsTable from './SupportRequestsTable';
import textBubbleIcon from '../../img/icons/text-bubble.svg';
import style from '../../style/components/help/SupportRequests.module.scss';
import ButtonLink from '../ButtonLink';
import EmailsModal from '../EmailsModal';

const SupportRequests = ({ requests, isFetching, user }) => {
  const { t } = useTranslation();
  const [isEmailsModalOpen, setIsEmailsModalOpen] = useState(false);
  const inlineEmailEdit = useSelector(
    (state) => state.featureFlags.inlineEmailEdit,
  );

  const updateLink = inlineEmailEdit ? (
    <Link to="/profile#emails" />
  ) : (
    <ButtonLink onClick={() => setIsEmailsModalOpen(true)} />
  );
  const linkText = inlineEmailEdit
    ? t('help.updateDefaultEmailAddress')
    : t('help.updatePrimaryEmailAddress');

  return (
    <>
      {!inlineEmailEdit && (
        <EmailsModal
          isOpen={isEmailsModalOpen}
          handleCancel={() => setIsEmailsModalOpen(false)}
        />
      )}

      <section className={style.card}>
        <h3 className={style.title}>
          <img alt="text-bubble" src={textBubbleIcon} />
          My Open Tickets
        </h3>
        <p>
          <Trans
            i18nKey="help.description_contactEmail"
            values={{ email: user.email, linkText }}
            components={{ strong: <strong />, updateLink }}
          />
        </p>
        <SupportRequestsTable requests={requests} isFetching={isFetching} />
        <br />
        <p>
          <i>{t('help.description_alreadyAddressed')}</i>
        </p>
      </section>
    </>
  );
};

SupportRequests.propTypes = {
  requests: PropTypes.arrayOf(
    PropTypes.shape({
      created_at: PropTypes.string,
      description: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
      status: PropTypes.string,
    }),
  ).isRequired,
};

export default memo(SupportRequests);
